import React from 'react'
import {FormattedDate} from 'react-intl'
import styled from '@emotion/styled'
import {imageProvider} from 'utils/imageProvider'

import {Box} from '@vio/atlas/helpers/Box'
import {Image} from '@vio/atlas/Image'
import {truncateSingleLine} from '@vio/atlas/src/utils/truncate'
import {StarRating} from '@vio/atlas/StarRating'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {dateStringToMiddayDate} from '@vio/core/src/utils/date'

import {Line} from './Line'

export interface Props {
  imageUrl: string
  rating?: number
  hotelName: string
  checkIn: string
  checkOut: string
}

const ImageContainer = styled.div`
  height: 70px;
  width: 70px;
  max-width: 70px;
  flex-shrink: 0;
`
const NameAndRatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s100};
  overflow: hidden;
`

const HotelInfo = styled.div`
  display: flex;
  gap: ${cssTheme.layout.spacing.s400};
`

const CheckInOutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s300};
`

const HotelTitle = styled(Text)`
  ${truncateSingleLine()}
`

export const PriceTrendHotelCard: React.FC<Props> = ({
  imageUrl,
  rating,
  hotelName,
  checkIn,
  checkOut
}) => {
  return (
    <Box paddingTop="s400" paddingBottom="s400">
      <HotelInfo>
        <ImageContainer>
          <Image
            url={imageUrl}
            imageProvider={imageProvider}
            borderRadius="lg"
          />
        </ImageContainer>

        <NameAndRatingContainer>
          {rating && <StarRating rating={rating} size="xs" />}
          <HotelTitle variant="titleL" dir="auto">
            {hotelName}
          </HotelTitle>

          <CheckInOutWrapper>
            <Text variant="labelS">
              <FormattedDate
                value={dateStringToMiddayDate(checkIn)}
                month="short"
                day="2-digit"
                weekday="short"
              />
            </Text>
            <Line width={38} />
            <Text variant="labelS">
              <FormattedDate
                value={dateStringToMiddayDate(checkOut)}
                month="short"
                day="2-digit"
                weekday="short"
              />
            </Text>
          </CheckInOutWrapper>
        </NameAndRatingContainer>
      </HotelInfo>
    </Box>
  )
}
